/**
 * AdminGate — v.1-D §4.14 / §7.20.
 *
 * Redirect-correct admin gate. The mockup leaked route existence via an
 * inline error card; v.1-D corrects this per Decision D-004 — non-admin
 * users (including unauthenticated ones) are redirected to "/" with state
 * carrying the original location. The destination page MAY surface a
 * transient toast keyed off `state.reason === 'not_admin'` (not implemented
 * yet — the contract preserves the hook).
 *
 * Authority: reads `useCurrentMember()` per Decision D-003 — NEVER the JWT.
 * Loading state renders the shared <PageSkeleton/>.
 */
import type { JSX } from 'react';
// DevOps 2026-05-26: Navigate, useLocation, useCurrentMember, PageSkeleton
// imports removed — only referenced in the commented-out original logic
// below. Re-add when reverting the bypass.
import { Outlet } from 'react-router-dom';

export function AdminGate(): JSX.Element {
  // DevOps 2026-05-26: admin gate bypassed for dev clicking. Pairs with
  // the ProtectedShell bypass in src/layouts/ProtectedShell.tsx — see
  // there for full rationale. Revert this commit when auth lands.
  return <Outlet />;

  // Original (restored on revert):
  // const member = useCurrentMember();
  // const location = useLocation();
  // if (member === undefined) return <PageSkeleton />;
  // if (member === null || member.role !== 'admin') {
  //   return <Navigate to="/" replace state={{ from: location, reason: 'not_admin' }} />;
  // }
  // return <Outlet />;
}
